import React, { PureComponent } from 'react';
import Tooltip from '../tooltip';
import { Item } from '../rc-components/menu';
import MenuContext from './MenuContext';
class MenuItem extends PureComponent {
    constructor() {
        super(...arguments);
        this.onKeyDown = e => {
            this.menuItem.onKeyDown(e);
        };
        this.saveMenuItem = (menuItem) => {
            this.menuItem = menuItem;
        };
    }
    static get contextType() {
        return MenuContext;
    }
    render() {
        const { inlineCollapsed } = this.context;
        const props = this.props;
        const item = React.createElement(Item, Object.assign({}, props, { ref: this.saveMenuItem }));
        if (inlineCollapsed && props.level === 1) {
            return (React.createElement(Tooltip, { prefixCls: props.tooltipPrefixCls, title: props.children, placement: "right", overlayClassName: `${props.rootPrefixCls}-inline-collapsed-tooltip` }, item));
        }
        return item;
    }
}
MenuItem.isMenuItem = 1;
export default MenuItem;
